<form [formGroup]="form">
    <label *ngIf="label_block" class="m-0 html-label" [ngClass]="{'req':required}" [innerHtml]="label | HTMLFormatter"></label>

    <mat-form-field floatLabel="always" appearance="standard">
        <mat-label *ngIf="!label_block&&required" class="req">
          <span [innerHtml]="label | HTMLFormatter"></span>
        <span *ngIf="verification_required" style="float: right;font-weight: bold;color: #000;">
          <i *ngIf="verified_status == 1" title="Verified" class="fa fa-check-circle-o"
            style="pointer-events:visible !important;color: green;" aria-hidden="true"></i>
          <i *ngIf="!verified_status || verified_status == 2" title="Not Verified" class="fa fa-times-circle-o" [ngClass]="{'pr-3':notes}"
            style="pointer-events:visible !important;color: red;" aria-hidden="true"></i>
          <i *ngIf="notes" [title]="notes?notes:''" style="pointer-events:visible !important;"
            class="fa fa-commenting-o pr-3"></i>
          <i *ngIf="reason && verified_status == 2" [title]="reason?reason:''" style="pointer-events:visible !important;"
            class="fa fa-info"></i>
        </span>
        </mat-label>
        <mat-label *ngIf="!label_block&&!required" >
          <span [innerHtml]="label | HTMLFormatter"></span>
        <span *ngIf="verification_required" style="float: right;font-weight: bold;color: #000;">
          <i *ngIf="verified_status == 1" title="Verified" class="fa fa-check-circle-o"
            style="pointer-events:visible !important;color: green;" aria-hidden="true"></i>
          <i *ngIf="!verified_status || verified_status == 2" title="Not Verified" class="fa fa-times-circle-o" [ngClass]="{'pr-3':notes}"
            style="pointer-events:visible !important;color: red;" aria-hidden="true"></i>
          <i *ngIf="notes" [title]="notes?notes:''" style="pointer-events:visible !important;"
            class="fa fa-commenting-o pr-3"></i>
          <i *ngIf="reason && verified_status == 2" [title]="reason?reason:''" style="pointer-events:visible !important;"
            class="fa fa-info"></i>
        </span>
        </mat-label>
        <input matInput [placeholder]="placeholder" [value]="value" type="password" [id]="id" [style]="style"
            [formControlName]="controlName" [maxlength]="maxLength" [readonly]="disabled ? true : false" [name]="random_id">
        <mat-hint>{{hint}}</mat-hint>
        <mat-error>
            {{error_msg}}
        </mat-error>
    </mat-form-field>
</form>